function extend(gantt){

	gantt.destructor = function(){
		gantt.callEvent("onDestroy", []);

		this.clearAll();
		this.detachAllEvents();

		if(this.$root){
			delete this.$root.gantt;
		}

		this._eventRemoveAll();
		if(this.$layout){
			this.$layout.destructor();
		}

		this.resetLightbox();

		if(this._dp && this._dp.destructor){
			this._dp.destructor();
		}

		this.$services.destructor();

		for(var i in this){
			if(i.indexOf("$") === 0){
				delete this[i];
			}
		}
	};
}

module.exports = extend;
